import styled from 'styled-components'
import { Box, Typography } from 'src/components'
import { motion } from 'framer-motion'

export const OverContainerSection = styled(Box)`
    display: flex;
    justify-content: center;
    position: relative;
    align-items: center;
    flex-direction: column;
`
export const OverContainer = styled(Box)`
    width: 96%;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
    border-radius: 12px;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 96%;
        align-items: start;
        flex-direction: row;
        justify-content: space-between;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 1200px;
    }
`
export const InitialChallenge = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 96%;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        align-items: start;
        width: 48%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
    }
`
export const InitialTwo = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 96%;
    justify-content: space-between;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        flex-direction: row;
        align-items: start;
        width: 48%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 48%;
    }
`
export const SectionTitle = styled(Box)`
    display: flex;
    flex-direction: row;
    align-items: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const InitialChallengeTypography = styled(Typography)`
    font-family: inherit;
    font-style: normal;
    text-align: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 26px;
    }
`
export const ClientAndRefer = styled(Box)`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
    }
`
export const Refer = styled.a`
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const SectionTwo = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: start;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 100%;
    }
`
export const SectionTree = styled(Box)`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 96%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 38%;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        width: 38%;
    }
`
export const Image = styled.img`
    object-fit: contain;
    width: 100%;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
    }
`
export const TypographyHeader = styled(motion(Typography))`
    font-family: inherit;
    font-style: normal;
    line-height: 46px;
    color: transparent;
    background: ${({ theme }) => theme.colors.lineaGradiant};
    -webkit-background-clip: text;
    text-align: center;
    text-transform: uppercase;
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
        line-height: 54px;
    }
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.desktop}) {
        line-height: 69px;
    }
`
